import type { ICourseRepository } from './interfaces/ICourseRepository'
import type { Course } from '@/types'
import { getDocument } from '@/services/firestore'

export class FirestoreCourseRepository implements ICourseRepository {
  async getById(id: string): Promise<Course | null> {
    return getDocument<Course>('courses', id)
  }

  async getByIds(ids: string[]): Promise<Course[]> {
    const results: Course[] = []
    const uniqueIds = [...new Set(ids)]
    const promises = uniqueIds.map((id) => this.getById(id))
    const docs = await Promise.all(promises)
    for (const doc of docs) {
      if (doc) results.push(doc)
    }
    return results
  }
}
